/* global API_BASE_URL */

import { apiRepositoryFactory } from '@/factories/apiRepositoryFactory.js'
import { buildCrossDomainCvCurrentUrl } from '@/helpers/crossDomainCv'
import { truncateUrlForQuery } from '@/helpers/truncateUrlForQuery'
import axios from 'axios'

const FALLBACK_API_BASE_URL = '/service_api/v1'

const normalizeApiBaseUrl = (baseUrl) => {
  if (typeof baseUrl !== 'string' || baseUrl.length === 0) return FALLBACK_API_BASE_URL
  return baseUrl.replace(/\/+$/, '') || FALLBACK_API_BASE_URL
}

const createApiRepositories = (tagParams) => {
  // CI では .env が無く API_BASE_URL が未定義になるため、相対パスにフォールバックして疎通を保つ
  axios.defaults.baseURL = normalizeApiBaseUrl(API_BASE_URL);

  return {
    get: (name) => apiRepositoryFactory.get(name)(axios),
    // simple-request化（storeeel-infra#2）: カスタムヘッダーを付けると preflight が発生するため、
    // Tenant-Id / Current-URL 相当は各API呼び出しのクエリ/bodyに載せる
    commonRequestParams: () => ({
      tenant_id: tagParams.tenantId,
      // クロスドメインCV情報は配信判定に不要なため、current_url から除外する。
      // さらにエンコード後長を上限で切り詰め、リクエストURL全長が中間層の8KB上限に当たらないようにする
      current_url: truncateUrlForQuery(buildCrossDomainCvCurrentUrl(window.location.href)),
    }),
  }
}

export default createApiRepositories
